import React, { useEffect, lazy, createElement } from 'react';
/**
 * Aggressive performance optimization component
 * - Preconnects to external domains
 * - Defers non-critical resources
 * - Optimizes rendering
 */
export function PerformanceOptimizer() {
  useEffect(() => {
    // Preconnect to external domains for faster loading
    const preconnectDomains = ['https://connect.facebook.net', 'https://cdn.magicpatterns.com'];
    preconnectDomains.forEach(domain => {
      // Preconnect
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = domain;
      preconnect.crossOrigin = 'anonymous';
      document.head.appendChild(preconnect);
      // DNS prefetch as fallback
      const dnsPrefetch = document.createElement('link');
      dnsPrefetch.rel = 'dns-prefetch';
      dnsPrefetch.href = domain;
      document.head.appendChild(dnsPrefetch);
    });
    // Optimize images - add loading="lazy" to all images below the fold
    const optimizeImages = () => {
      const images = document.querySelectorAll('img');
      images.forEach((img, index) => {
        // First 2 images load eagerly, rest lazy
        if (index > 1 && !img.loading) {
          img.loading = 'lazy';
        }
        // Add decoding="async" for better performance
        if (!img.decoding) {
          img.decoding = 'async';
        }
      });
    };
    // Run image optimization after a short delay
    setTimeout(optimizeImages, 100);
    // Reduce motion for users who prefer it (performance boost)
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      document.documentElement.style.setProperty('--animation-duration', '0.01ms');
    }
  }, []);
  return null;
}